import axios from "axios";
import QS from "qs";
import store from "../store.js";
import { Message } from "element-ui";
import md5 from "js-md5";

// axios.defaults.baseURL = '/test';
// 请求超时时间
axios.defaults.timeout = 10000;

// post请求头
axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8";

// 请求拦截器
axios.interceptors.request.use(
  (config) => {
    // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
    const token = store.getters.gettoken || "";
    const refreshToken = md5(token + "woshixingluochen--woyaojiamitoken");
    config.headers = Object.assign(config.headers, {
      token: token,
      "refresh-token": refreshToken
    });
    return config;
  },
  (error) => {
    return Promise.error(error);
  }
);

// 响应拦截器
axios.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是200的情况
  (error) => {
    if (error.response.status) {
      switch (error.response.status) {
        case 500:
          Message.error("服务器内部错误");
          break;
        default:
          return Promise.reject(error.response);
      }
    }
  }
);
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get (url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params
      })
      .then((res) => {
        let { data, headers } = res;
        var token = store.getters.gettoken || "";
        if (headers.token && headers.token != token) {
          store.commit("settoken", headers.token);
        }
        // if (!headers.token){
        // 	store.commit('settoken', '');
        // 	store.commit('setuser', '');
        // }
        if (!data.errCode && !data.msg) {
          resolve(data);
          return;
        }
        let { errCode, msg } = data;
        if (errCode != "0") {
          if (msg) Message.error(msg);
          return;
        }
        resolve(data.data);
      })
      .catch((err) => {
        Message.error(err.data);
        reject(err.data);
      });
  });
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post (url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, QS.stringify(params))
      .then((res) => {
        console.log(res);
        let { data, headers } = res;
        var token = store.getters.gettoken || "";
        if (headers.token && headers.token != token) {
          store.commit("settoken", headers.token);
        }
        // if (!headers.token){
        // 	store.commit('settoken', '');
        // 	store.commit('setuser', '');
        // }
        if (!data.errCode && !data.msg) {
          resolve(data);
          return;
        }
        let { errCode, msg } = data;
        if (errCode != "0") {
          if (msg) Message.error(msg);
          return;
        }
        resolve(data.data);
      })
      .catch((err) => {
        Message.error(err.data);
        reject(err.data);
      });
  });
}

/**
 * upload方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function upload (url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
      .then((res) => {
        let { data, headers } = res;
        var token = store.getters.gettoken || "";
        if (headers.token && headers.token != token) {
          store.commit("settoken", headers.token);
        }
        if (!data.errCode && !data.msg) {
          resolve(data);
          return;
        }
        let { errCode, msg } = data;
        if (errCode != "0") {
          if (msg) Message.error(msg);
          return;
        }
        resolve(data.data);
      })
      .catch((err) => {
        Message.error(err.data);
        reject(err.data);
      });
  });
}
